module.exports = __webpack_public_path__ + "img/expoglitter_0961_apple_green.4ee8c982.jpg";